import {useState} from 'react';
import { handleForgetPassword } from '../../../api/Auth';
import CustomLabelInput from '../../../components/Custom/CustomLabelInput';

import {
    Button,
    Grid,
    Link,
    Stack,
} from "@mui/material";

import { useTheme } from '@mui/material/styles';


import * as Yup from "yup";
import { Formik } from "formik";

import { Link as RouterLink, useNavigate } from 'react-router-dom';



const RecieveReset = () => {
    const navigate = useNavigate();

    const theme = useTheme();
    const LOADING_COLOR= theme.palette.action.disabled;
    const [loading, setLoading] = useState(false);

    return (
    <>
      <Formik
        initialValues={{
            email: "",
            submit: null,
        }}
        validationSchema={Yup.object().shape({
            email: Yup.string()
            .email("Please enter valid email")
            .max(255, "Email address must be maximum 255 characters long")
            .required("Please enter valid email")
            .test("valid-domain", "Invalid email domain", (value) => {
              return value.toLowerCase().endsWith("@assaabloy.com") || value.toLowerCase().endsWith("@qburst.com");
            })
        })}
        onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
            setStatus({ success: false });
            setSubmitting(false);
            setLoading(true);

            try{
                const sendCodeToEmail = await handleForgetPassword(values.email);
                if(sendCodeToEmail.CodeDeliveryDetails.AttributeName === "email"){
                    setStatus({ success: true})
                    setErrors({});
                    navigate("/verify_code", {state: values});
                }else {
                    setStatus({ success: false });
                    setErrors({ email: 'Failed to send code. Please try again.' });
                }
                setLoading(false);

            }catch(err){
                setErrors({ email: 'An error occurred while trying to reset the password.' });
                setStatus({ success: false});
                setLoading(false);
            }
        }}
      >
        {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting,
            touched,
            values,
        }) => (
          <form noValidate onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Stack spacing={1}>
                    <CustomLabelInput
                        name="email"
                        placeholder="Enter your email"
                        label="Email"
                        type="text"
                        disabled={loading}
                        maxLength={255}
                    />
                </Stack>
              </Grid>
              <Grid item xs={12}>
                   <Button
                    disableElevation
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={loading}
                  >
                    Send email
                  </Button>
                
              </Grid>

              <Grid item xs={12}>
                <Link
                    variant="h6"
                    component={RouterLink}
                    to="/login"
                    disabled={loading}
                    onClick= {(e)=> loading && e.preventDefault()}
                    sx= {{
                        color: !loading ? "primary.darker" : LOADING_COLOR,
                    }}
                >
                    Back to login
                </Link>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </>
  );
}


export default RecieveReset;